import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  textAlign: 'center',
  '& .HSTitle': {
    lineHeight: theme.typography.pxToRem(28),
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(32),
    color: theme.palette.common.fogWhite,
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
    '&.HSTitleHint': {
      color: theme.palette.common.fogWhite,
    },
    '&.HSOrange': {
      color: theme.palette.primary.main,
    },
  },
  '& .HSSubTitle': {
    color: theme.palette.grey[100],
  },
  '& .HSBtn': {
    margin: theme.spacing(3, 0),
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(24),
  },
}));

export default StyledBox;
